<template>
  <div class="form-group">
    <label v-if="label" class="form-label text-muted">
      {{ label }} <span v-if="required" class="text-danger">*</span>
    </label>
    <textarea
      style="resize: none"
      v-if="readOnly"
      :rows="rows"
      class="form-control form-disabled"
      :value="value"
      disabled
    />
    <textarea
      v-else
      :rows="rows"
      class="form-control"
      v-model.trim="model.$model"
      :class="{ 'is-invalid': model.$error }"
      :type="type"
      :placeholder="placeholder"
      :maxlength="maxLength"
    />

    <div class="invalid-feedback">
      <small>{{ errorMsg }}</small>
    </div>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  props: {
    model: {
      required: false,
      default: () => {},
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    errorMsg: {
      type: String,
      default: "Por favor, preencha este campo corretamente",
    },
    value: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: 1024,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 6,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
